export default {
  navigationBarTitleText: '医保小智',
};
